import axios from "axios";
import { ServerSideTypes } from "../../common/CommonTypes";

const ExportService = {
  get: {
    asyncExport: (serverParams: ServerSideTypes.IParams) => {
      return axios
        .get("/fs/asyncexport", {
          params: {
            ...serverParams,
          },
        })
        .then((response) => response.data);
    },

    asyncExportById: (id: number) => {
      return axios.get(`/fs/asyncexport/${id}/file`, {
        responseType: "arraybuffer",
        headers: { "Access-Control-Allow-Origin": true },
      });
    },
  },
};

export default ExportService;
